import styled from 'styled-components'

import BaseNotificationDot from './BaseNotificationDot'

const UnfilledNotificationDot = styled(BaseNotificationDot)`
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
`

export default UnfilledNotificationDot
